import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'cc-price',
  templateUrl: './price.component.html',
  styleUrls: ['./price.component.scss']
})
export class PriceComponent implements OnInit {
  @Input() price: number;
  @Input() isFree: boolean;

  constructor() {}

  ngOnInit() {}
}
